import { render, staticRenderFns } from "./member_list.vue?vue&type=template&id=5c84ef53"
import script from "./member_list.vue?vue&type=script&lang=js"
export * from "./member_list.vue?vue&type=script&lang=js"
import style0 from "./member_list.vue?vue&type=style&index=0&id=5c84ef53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports